export class Designation {
  id: number;
  designation: string;
}
